<template>
  <div class="special-zones-wrapper">
    <v-menu
      offset-y
      transition="scale-transition"
      :close-on-content-click="false"
      content-class="special-zones-menu"
    >
      <template v-slot:activator="{ on, attrs }">
        <div
          class="special-zones-btn"
          v-bind="attrs"
          v-on="on"
        >
          Special Zones
          <span class="arrow">▼</span>
        </div>
      </template>

      <v-card
        class="zones-card"
        flat
      >
        <v-list
          dense
          class="zones-list"
        >
          <v-list-item
            v-for="zone in zones"
            :key="zone.value"
            class="zone-item"
          >
            <div
              class="color-dot"
              :style="{ backgroundColor: zone.color }"
            />

            <v-checkbox
              v-model="selected[zone.value]"
              hide-details
              class="zone-checkbox"
              @change="() => onZoneToggle(zone.value)"
            >
              <template v-slot:label>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      class="zone-label"
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ zone.label }}
                    </span>
                  </template>
                  <span>{{ zone.description }}</span>
                </v-tooltip>
              </template>
            </v-checkbox>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "SpecialZonesDropdown",
  data() {
    return {
      selected: {},
      zones: [
        {
          label: "ECA",
          value: "eca",
          color: "#E60000", // was #ff3b3b
          description:
            "All ECA areas that are part of the International Convention for the Prevention of Pollution from Ships (MARPOL) Annex VI.",
        },
        /*{
          label: "NECA",
          value: "neca",
          color: "#ff8800",
          description: "ECAs controlling Nitrogen Oxides (NOx) emissions.",
        },
        */
        {
          label: "SECA",
          value: "seca",
          color: "#E6C200", // was #ffd600
          description: "ECAs controlling Sulphur Oxides (SOx) emissions.",
        },
        {
          label: "Marpol",
          value: "marpol",
          color: "#0F5CC8", // was #1976d2
          description: "Marpol Special Areas.",
        },
        {
          label: "High Risk",
          value: "high_risk_areas",
          color: "#6A1BB2", // was #8e24aa
          description: "High Risk Areas.",
        },
        /*{
          label: "rec_shipping_lanes",
          value: "rec_shipping_lanes",
          color: "#26a69a",
          description: "Recommended shipping lanes.",
        },
        */
        {
          label: "Joint War",
          value: "jwla",
          color: "#2E8F2E", // was #43a047
          description: "Joint War Listed Areas.",
        },
        {
          label: "Loadline Zones",
          value: "loadline_zones",
          color: "#00acc1",
          description: "International Load Line Zones.",
        },
        /*
        {
          label: "Navigating Limits",
          value: "nav_limits",
          color: "#26a69a",
          description: "International Navigating Limits.",
        },
        */
        {
          label: "Voluntary Reporting Areas",
          value: "vra",
          color: "#ef5350",
          description: "Voluntary Reporting Areas.",
        },
        /*
        {
          label: "Whale Protection Areas",
          value: "whale_protection_areas",
          color: "#ab47bc",
          description: "Whale Protection Areas.",
        },
        */
      ],
    };
  },
  methods: {
    onZoneToggle(zoneValue) {
      // same event used for ON/OFF toggling in your store
      this.$emit("zoneSelected", zoneValue);
    },
  },
};
</script>

<template>
  <div class="special-zones-wrapper">
    <v-menu
      offset-y
      transition="scale-transition"
      :close-on-content-click="false"
      content-class="special-zones-menu"
    >
      <template v-slot:activator="{ on, attrs }">
        <div class="special-zones-btn" v-bind="attrs" v-on="on">
          Special Zones
          <span class="arrow">▼</span>
        </div>
      </template>

      <v-card class="zones-card" flat>
        <v-list dense class="zones-list">
          <v-list-item
            v-for="zone in zones"
            :key="zone.value"
            class="zone-item"
          >
            <div class="color-dot" :style="{ backgroundColor: zone.color }" />

            <v-checkbox
              :input-value="isZoneChecked(zone.value)"
              hide-details
              class="zone-checkbox"
              @change="onZoneToggle(zone.value)"
            >
              <template v-slot:label>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span class="zone-label" v-bind="attrs" v-on="on">
                      {{ zone.label }}
                    </span>
                  </template>
                  <span>{{ zone.description }}</span>
                </v-tooltip>
              </template>
            </v-checkbox>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SpecialZonesDropdown",
  data() {
    return {
      zones: [
        {
          label: "ECA",
          value: "eca",
          color: "#E60000",
          description:
            "All ECA areas that are part of the International Convention for the Prevention of Pollution from Ships (MARPOL) Annex VI.",
        },
        {
          label: "SECA",
          value: "seca",
          color: "#E6C200",
          description: "ECAs controlling Sulphur Oxides (SOx) emissions.",
        },
        {
          label: "Marpol",
          value: "marpol",
          color: "#0F5CC8",
          description: "Marpol Special Areas.",
        },
        {
          label: "High Risk",
          value: "high_risk_areas",
          color: "#6A1BB2",
          description: "High Risk Areas.",
        },
        {
          label: "Joint War",
          value: "jwla",
          color: "#2E8F2E",
          description: "Joint War Listed Areas.",
        },
        {
          label: "Loadline Zones",
          value: "loadline_zones",
          color: "#00acc1",
          description: "International Load Line Zones.",
        },
        {
          label: "Voluntary Reporting Areas",
          value: "vra",
          color: "#ef5350",
          description: "Voluntary Reporting Areas.",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("weatherRouting/specialZones", ["isZoneActive"]),
  },
  methods: {
    isZoneChecked(zoneValue) {
      return this.isZoneActive(zoneValue);
    },
    onZoneToggle(zoneValue) {
      this.$emit("zoneSelected", zoneValue);
    },
  },
};
</script>

<style scoped>
.special-zones-wrapper {
  pointer-events: auto;
  min-width: 170px;
}

/* Button (dropdown activator) */
.special-zones-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;

  background: linear-gradient(135deg, #1f4e6d, #163c55);
  color: #ffffff;

  font-weight: 600;
  font-size: 14px;

  padding: 10px 16px;
  border-radius: 10px;
  border: 2px solid #000; /* black border like you wanted */
  cursor: pointer;
  user-select: none;

  box-shadow: #000000;
}

.arrow {
  margin-left: 10px;
}

/* Dropdown card */
.zones-card {
  background: #24465f !important; /* blue */
  border: 3px solid #000 !important; /* black border */
  border-radius: 6px !important;
  padding: 6px !important;
  width: 260px;
}

/* List */
.zones-list {
  background: transparent !important;
  padding: 0 !important;
}

.zone-item {
  min-height: 24px !important;
  padding: 0px 4px !important;
}

/* Dot */
.color-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
  flex: 0 0 auto;
}

/* Checkbox spacing cleanup */
.zone-checkbox {
  margin: 0 !important;
  padding: 0 !important;
}

:deep(.v-input--selection-controls.v-input) {
  margin: 0 !important;
  padding: 0 !important;
  min-height: 24px !important;
}

:deep(.v-input__slot) {
  margin: 0 !important;
  padding: 0 !important;
}

:deep(.v-messages) {
  display: none !important;
}

:deep(.v-input--selection-controls__input) {
  margin-right: 6px !important;
}

/* Label */
.zone-label {
  color: #ffffff;
  font-size: 13px;
  line-height: 1.05;
}
</style>
